import { render, staticRenderFns } from "./FormattedAddress.vue?vue&type=template&id=16bd596b&scoped=true&"
import script from "./FormattedAddress.vue?vue&type=script&lang=ts&"
export * from "./FormattedAddress.vue?vue&type=script&lang=ts&"
import style0 from "./FormattedAddress.vue?vue&type=style&index=0&id=16bd596b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bd596b",
  null
  
)

export default component.exports